import axios, { AxiosHeaders, InternalAxiosRequestConfig } from "axios";
import { KeycloakRPTSingleton, KeycloakSingleton } from "../components/keycloak-provider";
import { getPropertyFromRptToken, isJWTTokenExpired } from "../lib/auth";

const API_PREFIXES = [
  "api/properties",
  "api/property",
  "api/backoffice",
  "api/billings",
  "api/filters",
];

const axiosInstance = axios.create();

export function injectAuthHeaderIfNotPresent(
  resConfig: InternalAxiosRequestConfig
): InternalAxiosRequestConfig {
  const commonHeaders = new AxiosHeaders(resConfig.headers);

  if (!KeycloakSingleton) {
    window.location.reload();
    return { headers: commonHeaders };
  }

  if (KeycloakSingleton.isTokenExpired() || !KeycloakSingleton.token) {
    window.location.reload();
    return { headers: commonHeaders };
  }

  if (KeycloakRPTSingleton.rpt && isJWTTokenExpired(KeycloakRPTSingleton.rpt)) {
    window.location.reload();
    return { headers: commonHeaders };
  }

  const accessToken = KeycloakRPTSingleton.rpt ?? KeycloakSingleton.token;
  const currentAuthorizationHeader =
    resConfig.headers?.Authorization || resConfig.headers?.authorization;
  delete resConfig.headers?.Authorization;
  delete resConfig.headers?.authorization;

  commonHeaders.set("Authorization", currentAuthorizationHeader || `Bearer ${accessToken}`);
  const propertyTicker = getPropertyFromRptToken(accessToken);
  if (propertyTicker && API_PREFIXES.some(path => resConfig.url?.includes(path))) {
    commonHeaders.set("x-property", propertyTicker);
  }

  return { ...resConfig, headers: commonHeaders };
}

axiosInstance.interceptors.request.use(injectAuthHeaderIfNotPresent);

// FIXME: DO NOT USE THIS INSTANCE IN NEW CODE, THIS IS ONLY A CENTRALIZED WAY OF USING A SECURED AXIOS INSTANCE FOR LEGACY CODE
// Instead make use of the webhook useHttpClient(<YOUR_BASE_URL>) in your react components or pass it to your api functions.
export default axiosInstance;
